import FormItem from "@components/formItem/index.js";
import Loading from "@components/loading/index.jsx";
import NextIcon from "@layouts/v4/authPopup/icons/Next.jsx";
import PrevIcon from "@layouts/v4/authPopup/icons/Prev.jsx";
import ArrowRightActive from "@pages/profile-v2/assets/icons/ArrowRightActive.jsx";
import ButtonNextIcon from "@pages/profile-v2/assets/icons/ButtonNextIcon.jsx";
import FloatingLabelInput from "@pages/profile-v2/pages/deposit/FloatingLabelInput/index.js";
import { PaymentContentWrapper } from "@pages/profile-v2/pages/withdraw/baseItems.js";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import { getUser } from "@utils/index.js";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Translate } from "react-localize-redux";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import {
	BonusButton,
	BonusContainer,
	BonusDescription,
	BonusRadioButton,
	BonusText,
	Box,
	BoxTitle,
	Content,
	ContentTitle,
	ExternalButton,
	ExternalWrapper,
	Feature,
	FeatureBankName,
	FeatureTitleBox,
	Logo,
	MinMaxInfo,
	Navigation,
	NavigationItem,
	Page,
	PaymentWrapper,
	StakeFieldWrapper,
	Title,
} from "../baseItems.js";

var cardValidator = require("card-validator");

export default class Base extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			currentStep: 1,
			selectedBonus: null,
			stake: null,
			externalUrl: null,
			showSuccessWindow: false,
			showFailWindow: false,
			showSelectionWindow: false,
			claimsBonus: false,
			canForward: false,
			cryptocurrency: "",
			selectedCurrency: "",
			account: "",
			paymentMethod: "",
			selectedBank: "",
			thorpayReferenceCode: "",
			branchCode: "",
			ssn: "",
			recipientSSN: "",
			recipientBirthDate: "",
			fullName: "",
			iban: "",
			senderMobile: "",
			recipientMobile: "",
		};
		this.registeredFields = {};
	}

	componentDidMount() {
		const { selectedDeposit } = this.props;
		const { selectedCurrency } = this.state;
		const currencies = selectedDeposit?.currencies || [];

		if (!selectedCurrency && currencies.length > 0) {
			// TRY varsa onu seç, yoksa ilk currency'yi seç
			const hasTry = currencies.some((item) => item.currency === "TRY");
			const defaultCurrency = hasTry ? "TRY" : currencies[0].currency;
			this.setState({ selectedCurrency: defaultCurrency });
		}
	}

	onBackToDepositPage = () => {
		this.setState({
			currentStep: 1,
			stake: null,
			selectedBonus: null,
			externalUrl: null,
			showFailWindow: false,
			showSuccessWindow: false,
			showSmsWindow: false,
			showSelectionWindow: false,
			claimsBonus: false,
			canForward: false,
			cryptocurrency: "",
			selectedCurrency: "",
			account: "",
			paymentMethod: "",
			selectedBank: "",
			thorpayReferenceCode: "",
			branchCode: "",
			ssn: "",
			recipientSSN: "",
			recipientBirthDate: "",
			fullName: "",
			iban: "",
			senderMobile: "",
			recipientMobile: "",
		});
		this.props.onBackToDepositPage();
	};

	getCurrencyIcon(code) {
		if (code == "EUR") {
			return String.fromCharCode(8364);
		} else if (code == "TRY") {
			return String.fromCharCode(8378);
		} else if (code == "USD") {
			return String.fromCharCode(36);
		} else {
			return;
		}
	}

	registerField = ({ name, regex, message = "This field is required" }) => {
		this.registeredFields[name] = {
			regex,
			message,
		};
		this.checkRequiredFields(false);
	};

	getFullName() {
		if (this.props.user && this.props.user.family_name && this.props.user.given_name) {
			return `${this.props.user.given_name} ${this.props.user.family_name}`;
		}
		return null;
	}

	getAvailableBonuses(newStep) {
		const { selectedDeposit } = this.props,
			{ stake, selectedCurrency } = this.state;
		let dataToSend = {
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			paymentMethod: selectedDeposit.id,
			username: getUser().username,
		};
		this.props.externalFunc.getFilteredBonuses(
			dataToSend,
			(items) => {
				if (items?.length > 0) {
					this.setState({ currentStep: newStep });
				} else {
					this.makeExternalPayment(newStep + 1);
				}
			},
			() => {
				this.onSelectBonusClaim.bind(this, false);
				this.setState({ currentStep: newStep + 1 });
				this.goForward(newStep);
			}
		);
	}

	checkCreditCardNumber = (cardNumber) => {
		if (cardNumber) {
			let replacedCardNumber = cardNumber.replaceAll("/", "").replaceAll("_", ""),
				result = cardValidator.number(replacedCardNumber);
			return result.isValid;
		}
		return false;
	};

	getCardType = (cardNumber) => {
		if (cardNumber) {
			let replacedCardNumber = cardNumber.replaceAll("/", "").replaceAll("_", ""),
				result = cardValidator.number(replacedCardNumber);
			return result.card.type;
		}
		return null;
	};

	checkHolderName = (name) => {
		if (name) {
			let result = cardValidator.cardholderName(name);
			return result.isValid;
		}
		return false;
	};

	checkExpirationDate = (date) => {
		if (date) {
			let splitedDate = date.replaceAll("_", "").split("/"),
				resultMonth = cardValidator.expirationMonth(splitedDate[0]),
				resultYear = cardValidator.expirationYear(splitedDate[1]);
			return resultMonth.isValid && resultYear.isValid;
		}
		return false;
	};

	checkCvv = (cvv) => {
		if (cvv) {
			let result = cardValidator.cvv(cvv);
			return result.isValid;
		}
		return false;
	};
	checkRequiredFields = (showWarning) => {
		let flag = false;
		let missingFields = [];
		//todo: improve beause we can get regex and
		Object.keys(this.registeredFields).map((i) => {
			const val = this.state[i];
			if (val === "" || val === null || val === undefined) {
				flag = true;
				missingFields.push(i);
			}
		});
		if (flag) {
			if (showWarning) {
				this.props.showAlert({
					type: "error",
					msg: "ALL_FIELDS_WARNING",
					title: "ERROR",
				});
			}
			this.setState({ canForward: false });
			return false;
		}
		this.setState({ canForward: true });
		return true;
	};

	formatNumberDepositAmount(amount) {
		const { selectedDeposit } = this.props;
		return selectedDeposit?.name.indexOf("CRYPTOPAYMENT") > -1 ? Number(amount) : `${amount}`;
	}

	goForward(step) {
		const newStep = step + 1,
			{ stake, selectedCurrency, claimsBonus, selectedBonus, iban, canForward } = this.state,
			{ selectedDeposit } = this.props;
		const currency = selectedDeposit.currencies.find(
			(item) => item.currency == selectedCurrency
		);
		if (!canForward) return;
		switch (newStep) {
			case 2: {
				if (!this.checkRequiredFields(true)) {
					return;
				}

				if (
					selectedDeposit.id !== "PromotionalCode" &&
					selectedDeposit.name !== "MFT" &&
					selectedDeposit.name !== "MINIHAVALE" &&
					selectedDeposit.name !== "HIZLIPAPARA"
				) {
					if (stake < currency.deposit.min) {
						this.props.showAlert({
							type: "error",
							msg: "STAKE_RANGE_WARNING_MIN",
							title: "ERROR",
						});
						return;
					}
					if (stake > currency.deposit.max) {
						this.props.showAlert({
							type: "error",
							msg: "STAKE_RANGE_WARNING_MAX",
							title: "ERROR",
						});
						return;
					}
				}

				if (selectedDeposit.name === "BANKTRANSFER") {
					if (iban.includes("TR29 0014 3")) {
						this.props.showAlert({
							type: "error",
							msg: "IBAN_BLOCKED",
							title: "ERROR",
						});
						return;
					}
				}

				this.getAvailableBonuses(newStep);
				break;
			}
			case 3: {
				if (selectedDeposit.name === "THORPAY") {
					this.setState({
						currentStep: newStep,
					});
				} else {
					if (claimsBonus) {
						this.makeExternalPaymentWithBonus(newStep, selectedBonus.id);
					} else {
						this.makeExternalPayment(newStep);
					}
				}
				break;
			}
			case 4: {
				if (this.state.showSmsWindow) {
					this.onSendSms();
				} else if (this.onFinish) {
					this.onFinish();
				}
				break;
			}
			default:
				this.setState({
					currentStep: newStep,
				});
		}
	}

	goBack(step) {
		const { availableBonuses } = this.props;

		if (step === 3 && (!availableBonuses || availableBonuses.length === 0)) {
			this.setState({
				currentStep: 1,
				showSmsWindow: false,
				showFailWindow: false,
				showSuccessWindow: false,
				showSelectionWindow: false,
			});
			return;
		}

		this.setState({
			currentStep: step,
			showSmsWindow: false,
			showFailWindow: false,
			showSuccessWindow: false,
			showSelectionWindow: false,
		});
	}

	onEnterValue(name, e) {
		switch (name) {
			case "stake": {
				let v = e.target.value;
				v = v ? parseInt(v) : 0;
				this.setState(
					{
						stake: v,
					},
					() => {
						this.checkRequiredFields(false);
					}
				);
				break;
			}
			default: {
				let newState = { ...this.state };
				newState[name] = e.target.value;
				this.setState(newState, () => {
					this.checkRequiredFields(false);
				});
			}
		}
	}

	onSelectCurrency(e) {
		this.setState({
			selectedCurrency: e.label,
		});
	}

	onSelectPaymentMethod(e) {
		let method = e.target.value;
		this.props.externalFunc.getBankList(method, () => {
			this.setState({
				paymentMethod: method,
			});
		});
	}

	getCurrencyField = (translate) => {
		const { selectedDeposit } = this.props;
		const { selectedCurrency } = this.state;
		if (!selectedDeposit?.currencies?.length) return null;

		const currencies = [...selectedDeposit.currencies];
		const tryIndex = currencies.findIndex((item) => item.currency === "TRY");
		if (tryIndex > 0) {
			const [tryCurrency] = currencies.splice(tryIndex, 1);
			currencies.unshift(tryCurrency);
		}

		const options = [{ value: 0, label: translate("PLEASE_SELECT") }];
		currencies.forEach((item, idx) => {
			options.push({ value: idx + 1, label: item.currency });
		});

		const selectedValue = selectedCurrency
			? options.find((o) => o.label === selectedCurrency)?.value
			: currencies[0]
				? 1
				: options[1]?.value;

		if (!selectedCurrency && currencies[0]) {
			this.setState({ selectedCurrency: currencies[0].currency });
		}

		return (
			<Translate>
				{({ translate }) => (
					<FormItem onRegister={() => this.registerField({ name: "selectedCurrency" })}>
						<Box>
							<BoxTitle data-testid="step-deposit-amount-currency-picker-label">{translate("signin-signup.currency")}</BoxTitle>
							<PaymentSelect
								data-testid="step-deposit-amount-currency-picker-button"
								selected-text-data-testid="step-deposit-amount-currency-picker-selected-text"
								options={options}
								value={selectedValue}
								handleSelect={this.onSelectCurrency.bind(this)}
							/>
						</Box>
					</FormItem>
				)}
			</Translate>
		);
	};
	getStakeField = (label, autoFocus = true) => {
		return (
			<Translate>
				{({ translate }) => (
					<FormItem onRegister={() => this.registerField({ name: "stake" })}>
						<Box>
							<FloatingLabelInput
								data-testid="step-deposit-amount-amount-input"
							label-data-testid="step-deposit-amount-amount-label"
								onWheel={(e) => e.target.blur()}
								min={0}
								autoFocus={autoFocus}
								type="number"
								onChange={this.onEnterValue.bind(this, "stake")}
								label={translate("Enter_Amount")}
								translate={translate}
							/>
						</Box>
					</FormItem>
				)}
			</Translate>
		);
	};

	onSelectBank(e) {
		this.setState({
			selectedBank: e.target.value,
		});
	}

	onSelectBonusClaim(claimsBonus, bonus) {
		const { selectedBonus } = this.state;
		if (bonus && bonus.id) {
			if (selectedBonus && selectedBonus.id === bonus.id) {
				this.setState({ claimsBonus, selectedBonus: null });
			} else {
				this.setState({ claimsBonus, selectedBonus: bonus });
			}
		} else {
			this.setState({ claimsBonus: false, selectedBonus: "No Bonus" });
		}
	}

	renderMinMax() {
		const { selectedCurrency } = this.state;
		const { selectedDeposit } = this.props;

		const currencyToUse = selectedCurrency || selectedDeposit?.currencies?.[0]?.currency;

		const currency = selectedDeposit.currencies.filter(
			(item) => item.currency == currencyToUse
		);

		return (
			<Translate>
				{({ translate }) => (
					<div>
						{currency && currency[0] && currency[0].deposit && (
							<MinMaxInfo data-testid="step-deposit-amount-limits">
								{`${translate("MIN")}${formatMoney(
									currency[0].deposit.min,
									currencyToUse
								)} - ${translate("MAX")}${formatMoney(
									currency[0].deposit.max,
									currencyToUse
								)}`}
							</MinMaxInfo>
						)}
					</div>
				)}
			</Translate>
		);
	}

	getStep1(translate) {
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>
				<PaymentContentWrapper>
					<div>{this.getCurrencyField(translate)}</div>
					<div>
						<StakeFieldWrapper>
							<div className="stake-field">{this.getStakeField()}</div>
							<div className="min-max-field">{this.renderMinMax()}</div>
						</StakeFieldWrapper>
					</div>
				</PaymentContentWrapper>
			</Content>
		);
	}

	getActiveLanguageCode() {
		const { selectedDeposit } = this.props;
		let activeLanguage =
			selectedDeposit && selectedDeposit.languages.filter((i) => i.active == true);
		return activeLanguage[0].code;
	}

	convertToSelectedCurrency(amount, rate) {
		if (rate) {
			return amount * rate;
		} else {
			return amount;
		}
	}

	getStep2(translate) {
		const { availableBonuses, selectedDeposit } = this.props;
		const { stake, selectedBonus, claimsBonus, selectedCurrency } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Bonus_Selection")}</ContentTitle>
				<BonusContainer>
					{availableBonuses?.map((b, idx) => {
						if (
							!stake ||
							!b.instruction.minAmount ||
							this.convertToSelectedCurrency(
								b?.instruction?.minAmount,
								selectedDeposit?.convertionRates?.[selectedCurrency]
							) <= stake
						) {
							let isBonusSelected = selectedBonus && selectedBonus.id === b.id;
							return (
								<>
									<BonusButton
										data-testid={`step-deposit-bonus-option-${idx}`}
										onClick={this.onSelectBonusClaim.bind(this, true, b)}
										isBonusSelected={isBonusSelected}>
										<BonusRadioButton
											isBonusSelected={isBonusSelected}></BonusRadioButton>
										<BonusText isBonusSelected={isBonusSelected}>
											{b?.name}
										</BonusText>
									</BonusButton>
									{isBonusSelected &&
										b.details &&
										b.details !== "<p><br></p>" && (
											<BonusDescription
												dangerouslySetInnerHTML={{ __html: b.details }}
											/>
										)}
								</>
							);
						}
					})}
					<BonusButton
						data-testid="step-deposit-bonus-option-no-bonus"
						isBonusSelected={!claimsBonus && selectedBonus === "No Bonus"}
						onClick={this.onSelectBonusClaim.bind(this, false)}>
						<BonusRadioButton
							isBonusSelected={
								!claimsBonus && selectedBonus === "No Bonus"
							}></BonusRadioButton>
						<BonusText>{translate("No_Bonus")} </BonusText>
					</BonusButton>
				</BonusContainer>
			</Content>
		);
	}

	sendDataToDataLayer = (event, url) => {
		const { selectedCurrency, stake, paymentMethod } = this.state;

		// Send data to GTM
		window?.dataLayer?.push({
			event: "deposit_started",
			currency: selectedCurrency,
			stake: stake,
			method: paymentMethod,
			username: getUser()?.username,
		});

		event.preventDefault();
		setTimeout(() => {
			window.open(url, "_blank");
		}, 200);
	};

	getStep3(translate) {
		const { selectedDeposit, loading } = this.props;
		const { externalUrl, claimsBonus, selectedBonus } = this.state;
		return (
			<Content>
				<ExternalWrapper>
					<Loading loading={loading} />
					<div>
						{claimsBonus ? (
							<ExternalButton
								data-testid="step-deposit-final-confirm-button"
								onClick={(e) => this.sendDataToDataLayer(e, externalUrl)}
								href={externalUrl}>
								{translate(
									"GO_EXTERNAL",
									{
										name: selectedDeposit.name,
										bonus: this.getBonusInfo(selectedBonus),
									},
									{ renderInnerHtml: true }
								)}
								<ButtonNextIcon />
							</ExternalButton>
						) : (
							<ExternalButton
								data-testid="step-deposit-final-confirm-button"
								onClick={(e) => this.sendDataToDataLayer(e, externalUrl)}
								href={externalUrl}>
								{translate(
									"GO_EXTERNAL_WOUT_BONUS",
									{ name: selectedDeposit.name },
									{ renderInnerHtml: true }
								)}
								<ButtonNextIcon />
							</ExternalButton>
						)}
					</div>
				</ExternalWrapper>
			</Content>
		);
	}

	getBonusInfo(bonus) {
		return bonus.instruction.type === "Standard Deposit"
			? "%".concat(bonus.instruction.percentage.toString()).concat(" BONUS")
			: bonus.instruction.type === "Value"
				? `${bonus.instruction.value} ${bonus.instruction.currency} BONUS`
				: `${bonus.instruction.tokenAmount} FREESPIN BONUS`;
	}

	getBackButton() {
		const { currentStep } = this.state;
		if (currentStep === 1) {
			return (
				<NavigationItem
					data-testid="step-deposit-nav-back"
					back={true}
					onClick={this.onBackToDepositPage}>
					<PrevIcon />
				</NavigationItem>
			);
		} else {
			return (
				currentStep !== 3 && (
					<NavigationItem
						data-testid="step-deposit-nav-back"
						back={true}
						onClick={this.goBack.bind(this, currentStep - 1)}>
						<PrevIcon />
					</NavigationItem>
				)
			);
		}
	}

	getForwardButton(selectedDeposit) {
		const { thorpayReferenceCode, currentStep, canForward, selectedBonus } = this.state;
		const isThorpayMethodReferenceNotPresent =
			selectedDeposit.name === "THORPAY" && thorpayReferenceCode === "";
		const isNotPapara = selectedDeposit.name !== "PAPARA";
		const enableForward =
			canForward && (currentStep === 2 ? selectedBonus && selectedBonus.id !== "" : true);
		if (isNotPapara && (currentStep < 3 || isThorpayMethodReferenceNotPresent)) {
			return (
				<NavigationItem
					data-testid="step-deposit-nav-next"
					filled={enableForward}
					onClick={this.goForward.bind(this, currentStep)}>
					{enableForward ? <ArrowRightActive /> : <NextIcon />}
				</NavigationItem>
			);
		} else {
			return null;
		}
	}

	renderNavigationButtons = () => {
		const navigationBtnsContainer = document.getElementById("navigation-btns");
		if (!navigationBtnsContainer) return null;

		const navigations = (
			<Navigation>
				{this.getBackButton()}
				{this.getForwardButton(this.props.selectedDeposit)}
			</Navigation>
		);

		return ReactDOM.createPortal(navigations, navigationBtnsContainer);
	};

	render() {
		const { currentStep } = this.state,
			{ selectedDeposit } = this.props;

		return (
			<Translate>
				{({ translate }) => (
					<PaymentWrapper>
						<Page>
							<Title data-testid={`step-deposit-${currentStep === 3 ? "final" : "amount"}-header`}>
								<Logo
									src={selectedDeposit.logo}
									className={selectedDeposit.logoCls || ""}
								/>
								<FeatureTitleBox>
									<FeatureBankName data-testid={`step-deposit-${currentStep === 3 ? "final" : "amount"}-header-title`}>
										{selectedDeposit.logoName
											? selectedDeposit.logoName
													.split(" ")
													.map((word) =>
														/^[A-Z]+$/.test(word)
															? word
															: word
																	.replace(
																		/([A-Z](?=[a-z]))/g,
																		" $1"
																	)
																	.trim()
													)
													.join(" ")
											: selectedDeposit.name
													.split(" ")
													.map((word) =>
														/^[A-Z]+$/.test(word)
															? word
															: word
																	.replace(
																		/([A-Z](?=[a-z]))/g,
																		" $1"
																	)
																	.trim()
													)
													.join(" ")}
									</FeatureBankName>
									<Feature bold={true}>{selectedDeposit.bonus}</Feature>
									<Feature data-testid={`step-deposit-${currentStep === 3 ? "final" : "amount"}-header-subtitle`} bold={true}>{selectedDeposit.feature}</Feature>
								</FeatureTitleBox>
							</Title>
							{currentStep === 1 && this.getStep1(translate)}
							{currentStep === 2 && this.getStep2(translate)}
							{currentStep === 3 && this.getStep3(translate)}
						</Page>
						{window.META_CONVERSION_SCRIPT &&
							window.META_CONVERSION_SCRIPT !== "" &&
							currentStep === 3 && (
								<div
									dangerouslySetInnerHTML={{
										__html: window.META_CONVERSION_SCRIPT,
									}}
								/>
							)}
						{this.renderNavigationButtons()}
					</PaymentWrapper>
				)}
			</Translate>
		);
	}
}
